<template>
<div class="chapter">
<div class="inner_page">
<p class="toch"><b>CONTENTS</b></p>
<p class="toc1"><a href="#/chapter1" id="cra">CRASH &amp; BURN</a></p>
<p class="toc"><a href="#/chapter1#ch01" id="ch1">1</a></p>
<p class="toc"><a href="#/chapter2#ch02" id="ch2">2</a></p>
<p class="toc"><a href="#/chapter3#ch03" id="ch3">3</a></p>
<p class="toc"><span href="#/chapter4#ch04" id="ch4" title="Link target outside of Sample">4</span></p>
<p class="toc"><span href="#/chapter5#ch05" id="ch5" title="Link target outside of Sample">5</span></p>
<p class="toc1"><span href="#/chapter6" id="the" title="Link target outside of Sample">THE GOOD SAMARITAN</span></p>
<p class="toc"><span href="#/chapter6#ch06" id="ch6" title="Link target outside of Sample">6</span></p>
<p class="toc"><span href="#/chapter7#ch07" id="ch7" title="Link target outside of Sample">7</span></p>
<p class="toc"><span href="#/chapter8#ch08" id="ch8" title="Link target outside of Sample">8</span></p>
<p class="toc"><span href="#/chapter9#ch09" id="ch9" title="Link target outside of Sample">9</span></p>
<p class="toc1"><span href="#/chapter10" id="bury" title="Link target outside of Sample">BURYING THE DEAD</span></p>
<p class="toc"><span href="#/chapter10#ch010" id="ch10" title="Link target outside of Sample">10</span></p>
<p class="toc"><span href="#/chapter11#ch011" id="ch11" title="Link target outside of Sample">11</span></p>
<p class="toc"><span href="#/chapter12#ch012" id="ch12" title="Link target outside of Sample">12</span></p>
<p class="toc1"><span href="#/chapter13" id="an" title="Link target outside of Sample">AN UNEXAMINED LIFE</span></p>
<p class="toc"><span href="#/chapter13#ch013" id="ch13" title="Link target outside of Sample">13</span></p>
<p class="toc"><span href="#/chapter14#ch014" id="ch14" title="Link target outside of Sample">14</span></p>
<p class="toc1"><span href="#/chapter15" id="ostt" title="Link target outside of Sample">POSTTRAUMATIC STRESS SYNDROME</span></p>
<p class="toc"><span href="#/chapter15#ch015" id="ch15" title="Link target outside of Sample">15</span></p>
<p class="toc"><span href="#/chapter16#ch016" id="ch16" title="Link target outside of Sample">16</span></p>
<p class="toc1"><span href="#/chapter17" id="crash" title="Link target outside of Sample">CRASH LANDING</span></p>
<p class="toc"><span href="#/chapter17#ch017" id="ch17" title="Link target outside of Sample">17</span></p>
<p class="toc"><span href="#/chapter18#ch018" id="ch18" title="Link target outside of Sample">18</span></p>
<p class="toc1"><span href="#/chapter19" id="aft" title="Link target outside of Sample">AFTERLIFE</span></p>
<p class="toc"><span href="#/chapter19#ch019" id="ch19" title="Link target outside of Sample">19</span></p>
<p class="toc"><span href="#/chapter20#ch020" id="ch20" title="Link target outside of Sample">20</span></p>
<p class="toc"><span href="#/chapter21#ch021" id="ch21" title="Link target outside of Sample">21</span></p>
<p class="toc"><span href="#/chapter22#ch022" id="ch22" title="Link target outside of Sample">22</span></p>
<p class="toc1"><span href="#/bio" id="bio" title="Link target outside of Sample">A BIOGRAPHY OF RAFAEL YGLESIAS</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?18fad1a4